<template>
    <v-menu v-model="menuShow" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="textValue"
                :label="label"
                append-outer-icon="event"
                :error="error"
                :error-messages="errorMessages"
                readonly
                v-bind="attrs"
                v-on="on"
                @click:append-outer="on.click"
            ></v-text-field>
        </template>
        <v-date-picker
            ref="picker"
            v-model="pickerValue"
            locale="nl-NL"
            :max="new Date().toISOString().substr(0, 10)"
            min="1902-01-01"
        ></v-date-picker>
    </v-menu>
</template>

<script>
export default {
    name: 'v-birthday-picker',
    components: {},
    props: {
        label: String,
        value: String,
        error: Boolean,
        errorMessages:String,
    },
    data: () => ({
        menuShow: false,
        pickerValue: null,
    }),
    created() {
        this.pickerValue = this.value;
    },
    watch: {
        menuShow(val) {
            if (val) {
                setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
            }
        },
        value(val) {
            this.pickerValue = val;
        },
        pickerValue(val) {
            this.$emit('input', val);
            this.menuShow = false;
        },
    },
    computed: {
        textValue() {
            let textValue = '';
            if (this.pickerValue) {
                const dateValue = new Date(this.pickerValue);
                textValue = dateValue.toLocaleDateString('nl-NL');
            }
            return textValue;
        },
    },
};
</script>
